export const environment = {
  production: true,
  adminApiUrl: 'https://admin.release.getlilo.io/admin',
  dictionariesApiUrl: 'https://admin.release.getlilo.io/protocols/dictionaries',
  packagesApiUrl: 'https://admin.release.getlilo.io',
  authorizationApiUrl: 'https://api.release.getlilo.io/access',
  protectedApiUrl: 'https://api.release.getlilo.io/protected',
  firebase: {
    apiKey: 'AIzaSyBH7rZDgJCLjcX_6aQNOsrEkgFWzgNXVEY',
    authDomain: 'lilo-staging-22c48.firebaseapp.com',
    projectId: 'lilo-staging-22c48',
    storageBucket: 'lilo-staging-22c48.firebasestorage.app',
    messagingSenderId: '813089851007',
    appId: '1:813089851007:web:5e12a0e8df5dd9e0070e2e',
    measurementId: 'G-4FRLQK4TN5',
    vapidKey: 'BD2TDFuhPzZcTWR5AO6ij9GWTNJ4uC3Nfkt50Yn0xlKhJG8d5ihIZCxngT6kYjCYQi7lwz9xN7nMSU7jCyXR12k',
  },
};
